import { atom, useAtom } from "jotai";

import { useAllLocations } from "~/hooks";
import { ALL_LOCATIONS } from "~/utils/Constants";

// Persists the location choice across the Data Analysis Overview pages, so the
// user picks once (in the dropdown above the tabs) and it follows them as they
// move between tabs.
const selectedLocationAtom = atom<string>("");

/**
 * `location` is empty while `isPending`: queries keyed on it stay disabled
 * until the plants the caller may pick are known.
 */
export const useSelectedLocation = () => {
  const { locations, isPending } = useAllLocations();
  const [stored, setStored] = useAtom(selectedLocationAtom);

  const location = isPending
    ? ""
    : locations.some((l) => l.value === stored)
      ? stored
      : (locations[0]?.value ?? ALL_LOCATIONS);

  return { location, setLocation: setStored, isPending };
};
